import hljs from 'highlight.js';
import './style.scss';

hljs.highlightAll();
